// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fOgd","question":"styles_question__3RH3r","inputVisibleButton":"styles_inputVisibleButton__1eMBC","note":"styles_note__2Xg87"};